import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { installVersionCheck } from './utils/versionCheck';
ReactDOM.createRoot(document.getElementById('root')).render(<React.StrictMode><App /></React.StrictMode>);
// Detect stale bundles after a deploy and offer a "new version" refresh banner
// (user-initiated reload — no jarring auto-refresh). Kills version skew calmly.
installVersionCheck();

// A chunk that is no longer on the server. The version check is polite — it
// offers a banner and waits — but a lazily-loaded chunk can be missing while
// the user is mid-click, and then there is nothing to wait for: the import
// rejects and whatever needed it never renders.
//
// This is the same deploy-skew the banner exists for, arriving as a hard
// failure instead of a poll. Reload once, straight away, with the marker that
// defeats every intermediate cache. Guarded by sessionStorage so a genuinely
// broken build cannot put the tab in a reload loop.
window.addEventListener('vite:preloadError', (e) => {
  try {
    if (sessionStorage.getItem('aone_chunk_reloaded')) return;   // already tried
    sessionStorage.setItem('aone_chunk_reloaded', String(Date.now()));
    e.preventDefault();
    window.location.replace(`${window.location.pathname}?fresh=${Date.now()}${window.location.hash}`);
  } catch { /* storage blocked — let the error surface rather than loop */ }
});
// A clean load means the skew is behind us; let the next one reload if needed.
window.addEventListener('load', () => {
  try { sessionStorage.removeItem('aone_chunk_reloaded'); } catch { /* ignore */ }
});

// The cache-reset paths land on /?fresh=<ts> so no intermediate cache can
// answer the shell request. Drop the marker once we are running — it has done
// its job and should not linger in the address bar or in shared links.
try {
  if (window.location.search.includes('fresh=')) {
    const url = new URL(window.location.href);
    url.searchParams.delete('fresh');
    window.history.replaceState({}, '', url.pathname + url.search + url.hash);
  }
} catch { /* non-critical */ }
